import { Injectable } from '@angular/core';
import { ArticleCategoryStore } from './article-category.store';
import { ArticleCategoryQuery } from './article-category.query';
import { BaseFacade } from "../base/base.facade";
import { ArticleCategoryService } from './article-category.service';
import { TranslateService } from '@ngx-translate/core';
import { DynamicSchemaFactory } from '../dynamic-schema.factory';

@Injectable({ providedIn: 'root' })
export class ArticleCategoryFacade extends BaseFacade {

    constructor(
        articleTypeService: ArticleCategoryService,
        articleTypeStore: ArticleCategoryStore,
        articleTypeQuery: ArticleCategoryQuery,
        dynamicSchemaFacto: DynamicSchemaFactory,
        translateService: TranslateService) {
        super(articleTypeService,
          articleTypeStore,
          articleTypeQuery,
          dynamicSchemaFacto.getDynamicSchemaFacade('article-category'),
          translateService,
          'article-category-facade'
          );
    }


}
